"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var hmrImport_native_exports = {};
__export(hmrImport_native_exports, {
  hmrImport: () => hmrImport
});
module.exports = __toCommonJS(hmrImport_native_exports);
function hmrImport(path) {
  var runtime = globalThis.__rolldown_runtime__;
  if (!runtime || typeof runtime.loadExports !== "function") {
    return Promise.reject(new Error("HMR import not supported on native"));
  }
  var id = path.replace(/^\.\//, "").replace(/^\//, "");
  return Promise.resolve().then(function() {
    var mod = runtime.loadExports(id);
    if (mod == null) {
      throw new Error(`no exports for ${id}`);
    }
    return mod;
  });
}
//# sourceMappingURL=hmrImport.native.js.map
